import * as React from 'react';
import { Tab } from 'ui';
import { TabProps } from '@material-ui/core';
import { Typography } from 'omakase';

export type ScrollListNavigationItemProps = TabProps;

/**
 * ScrollListNavigationItem is a custom button displayed in a list
 *
 * ```js
 * import { ScrollListNavigationItem } from 'components/business/ScrollListNavigation';
 * ```
 */
const ScrollListNavigationItem: React.FunctionComponent<ScrollListNavigationItemProps> =
  React.forwardRef(({ children, className, value, icon, label, ...rest }, ref) => {
    return (
      <Tab
        ref={ref}
        className={className}
        id={`${value}`}
        value={value}
        icon={icon}
        label={
          label && (
            <Typography variant="body02Strong" component="span" color="inherit">
              {label}
            </Typography>
          )
        }
        {...rest}
      />
    );
  });

export default ScrollListNavigationItem;
